import { useState, useEffect } from "react";

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
};

export default function useResponsive() {
  const getWidth = () =>
    typeof window !== "undefined" ? window.innerWidth : BREAKPOINTS.desktop;

  const [width, setWidth] = useState(getWidth());

  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidth());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    width,

    isMobile: width < BREAKPOINTS.mobile,

    isTablet:
      width >= BREAKPOINTS.mobile &&
      width < BREAKPOINTS.tablet,

    isDesktop: width >= BREAKPOINTS.tablet,

    breakpoint: BREAKPOINTS,
  };
}
